var map = {
	"./add.svg": "34cd",
	"./closeWeixin.svg": "a1c0",
	"./cont.svg": "1e37",
	"./content.svg": "5335",
	"./cover.svg": "953e",
	"./email.svg": "e127",
	"./hot.svg": "09b1",
	"./img.svg": "5dad",
	"./like.svg": "3005",
	"./liuyan.svg": "20cb",
	"./logout.svg": "cf8c",
	"./model.svg": "5aa3",
	"./more.svg": "08c7",
	"./music.svg": "449b",
	"./musics.svg": "6f86",
	"./play.svg": "7d00",
	"./playHall.svg": "6791",
	"./save.svg": "4cc6",
	"./scene.svg": "caac",
	"./set.svg": "61fd",
	"./share.svg": "d017",
	"./space.svg": "6e45",
	"./stopHall.svg": "e3b8",
	"./tel.svg": "967c",
	"./user.svg": "df32",
	"./video.svg": "776a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f74";